/* global API_URL */

export default (leagueSlug, id) =>
  fetch(`${API_URL}/${leagueSlug}/box_scores/${id}/action_shootouts?rpp=-1`).then(response =>
    response.json()
  );
